<template>
<span v-if="canAddDetail()">
  <el-button
    id="btn-add-shipment-detail"
    type="success"
    plain
    @click="dialogVisible = true"
    size="mini"
    class="button-action-default"
  >
    {{ $t('customerService.shipment.addDetail') }}
  </el-button>
  <el-dialog
    v-on:open="handleOpen"
    :title="$t('customerService.shipment.addDetail')"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="60%"
    append-to-body
    class="dialog-with-cols"
  >
    <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.product')" prop="productCode">
            <autocomplete
              :model.sync="form.productCode"
              :modelAdditional.sync="form.productDescription"
              :strict="false"
              :url="urlProduct"
              labelField="description"
              labelFieldLastWithDash="code"
              labelfieldSelected="code"
              valueField="code"
              valueFieldAdditional="description"
              :maxlength="5"
              id="form-product"
              ref="form-product"
            ></autocomplete>
          </el-form-item>
        </el-col>
        <el-col :md="12" :sm="24" :xs="24" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.productDescription')" prop="productDescription">
            <el-input
              v-model="form.productDescription"
              v-alphanumeric-validation
              maxlength="30"
              clearable
              class="inline-input"
              id="form-product-description"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.poNumber')" prop="po">
            <el-input
              v-model="form.po"
              v-alphanumeric-validation
              maxlength="25"
              clearable
              class="inline-input"
              id="form-po-number"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.numberOfUnits')" prop="numberUnits">
            <el-input-number
              v-model="form.numberUnits"
              v-numeric-validation
              :controls="false"
              :precision="0"
              :min="0"
              :max="999"
              @focus="$event.target.select()"
              class="width-100p"
              id="form-number-units"
              ref="unit"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.length')" prop="length">
            <el-input-number
              v-model="form.length"
              v-numeric-validation
              :controls="false"
              :precision="2"
              @focus="$event.target.select()"
              :min="0"
              :max="999.99"
              class="width-100p"
              id="form-length"
              ref="length"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.width')" prop="width">
            <el-input-number
              v-model="form.width"
              v-numeric-validation
              :controls="false"
              :precision="2"
              :min="0"
              :max="999.99"
              @focus="$event.target.select()"
              class="inline-input width-100p"
              id="form-width"
              ref="width"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.height')" prop="height">
            <el-input-number
              v-model="form.height"
              v-numeric-validation
              :controls="false"
              :precision="2"
              :min="0"
              :max="999.99"
              @focus="$event.target.select()"
              class="inline-input width-100p"
              id="form-height"
              ref="height"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('customerService.shipment.totalCubes')" prop="height">
            <el-input
              disabled
              :value="totalCubes"
              class="inline-input width-100p"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button
        type="primary"
        id="form-save-button"
        @click="submitForm"
        size="mini"
      >
        {{ $t('customerService.shipment.addDetail') }}
      </el-button>
      <el-button
        id="form-refresh-button"
        @click="resetForm"
        size="mini"
      >
        {{ $t('warehouse.orderEntry.clear') }}
      </el-button>
    </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  components: { Autocomplete },
  props: {
    shipmentId: {
      type: Number,
      default: null
    },
    shipmentStatus: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'shipment'
    ]),
    urlProduct() {
      return apiConstants.END_POINTS.PRODUCT_SEARCH;
    },
    totalCubes() {
      const {
        length, height, width, numberUnits
      } = this.form;

      return (((length * width * height) / 1728) * numberUnits).toFixed(2);
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        shipmentId: null,
        numberUnits: null,
        length: null,
        width: null,
        height: null,
        productCode: '',
        productDescription: '',
        po: ''
      },
      formRules: {
        length: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.lengthRequired'),
            trigger: 'blur'
          }
        ],
        width: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.widthRequired'),
            trigger: 'blur'
          }
        ],
        height: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.heightRequired'),
            trigger: 'blur'
          }
        ],
        numberUnits: [
          {
            required: true,
            message: this.$t(
              'customerService.shipment.error.numberUnitsRequired'
            ),
            trigger: 'blur'
          }
        ],
        productDescription: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.productDescriptionRequired'),
            trigger: 'blur'
          }
        ],
        productCode: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.productRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.form.shipmentId = this.shipmentId;
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.productCode = '';
      this.form.productDescription = '';
      this.$refs['form-product'].clearLocalModel();
    },
    canAddDetail() {
      const hasShipmentClosedOrCancelled = this.shipmentStatus === constants.SHIPMENT.STATUS[5].value
        || this.shipmentStatus === constants.SHIPMENT.STATUS[6].value;
      return (
        this.$can(this.permissions.BILLING.EDIT_SHIPMENT)
        && !this.shipment.isEditingDetails
        && !hasShipmentClosedOrCancelled
      );
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('shipment/addDetail', this.form)
            .then((response) => {
              this.$message.success(response.message);
              this.$emit('detailAdded');
              this.dialogVisible = false;
            })
            .finally(() => {
              loading.close();
            });
        }
      });
    }
  }
};
</script>
